import moment from "moment"

export const visitTypeColorGetter = (code, event, returnRGB = true) => {
    switch (code) {
        case "EXTERNAL": return returnRGB ? "#247dbd" : "rbc-event-blue";
        case "EXTERNAL_PHONE": return returnRGB ? "#20ad9b" : "rbc-event-green"
        case "OVERSHIFT": return returnRGB ? "#e0e32c" : "rbc-event-yellow"
        case "PROTOCOL": return returnRGB ? "#ffa534" : "rbc-event-orange"
        case "OTHER": return returnRGB ? "#5e5e5e" : "rbc-event-black"
        case "PROJECT": return returnRGB ? "#9368e9" : "rbc-event-purple"
        case "ESSENTIA": return returnRGB ? "#a6a6a6" : "rbc-event-gray"
        case "STUDIES": return returnRGB ? "#ca6e6e" : "rbc-event-red"
        case "PRESCREENING": return returnRGB ? "#e98101" : "rbc-event-orange";
        case "ORDER": return returnRGB ? "#23ccef" : "rbc-event-default";
        case "SCHEDULELOCK": {
            if (event?.practitioner)
                return returnRGB ? "rgba(255,165,52,0.2)" : "rbc-event-practitioner-lock";
            else
                return returnRGB ? "rgba(94,94,94,0.2)" : "rbc-event-lock";
        }
        default: return returnRGB ? "#23ccef" : "rbc-event-default";
    }
}

const dot = (color = '#ccc') => ({
    alignItems: 'center',
    display: 'flex',

    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
    },
});

export const colourStyles = {
    option: (styles, { data }) => {
        const color = visitTypeColorGetter(data.code);
        return { ...styles, ...dot(color) };
    }
};

export const validateAvailabilityDate = (current, _selected, practitionerAvailability) => {
    if (!practitionerAvailability || !practitionerAvailability.availableWeekDays)
        return false;

    if (!current.isSameOrAfter(moment().startOf('day')))
        return false;

    var availableDate = practitionerAvailability.availableDates.filter(x => moment(x.date).format('DD/MM/YYYY') === current.format('DD/MM/YYYY') && x.available);
    var availableWeekDays = practitionerAvailability.availableWeekDays.includes(current.day());

    return availableWeekDays && availableDate.length > 0;
}

// Un servicio medico (de Prebiller) esta asociado a la especialidad si la tiene en su lista specialties.
export const serviceHasSpecialty = (service, specialtyId) =>
    (service?.specialties ?? []).some(s => s.specialtyId === specialtyId);

// Servicios de la especialidad elegida. Se filtra en el cliente aunque el pedido ya mande la especialidad a
// Prebiller: no esta confirmado el nombre del parametro (SelectedSpeciaties, ver disponibilidad-especialidades.md
// B5) y si Prebiller lo ignora devuelve todos los servicios.
export const filterServicesBySpecialty = (services, specialtyId) =>
    specialtyId ? (services ?? []).filter(s => serviceHasSpecialty(s, specialtyId)) : (services ?? []);

// Etiqueta de un horario de la disponibilidad ("13:00:00"/"14:00:00" -> "13:00 - 14:00"). Con el rango se
// distinguen horarios que empiezan igual pero duran distinto (disponibilidades superpuestas el mismo dia).
export const formatSlotLabel = (slot) => {
    const hhmm = time => (time ?? '').substring(0, 5);
    return slot?.appointmentEnd ? `${hhmm(slot.appointmentInit)} - ${hhmm(slot.appointmentEnd)}` : hhmm(slot?.appointmentInit);
}

// Primer horario libre de la disponibilidad de un profesional (respuesta de currentavailability): el dia
// disponible mas temprano y, dentro de ese dia, el horario libre mas temprano. null si no hay ninguno.
export const getEarliestAvailableSlot = (practitionerAvailability) => {
    const day = (practitionerAvailability?.availableDates ?? [])
        .filter(x => x.available && (x.availableAppointments ?? []).some(a => a.available))
        .sort((a, b) => moment(a.date).diff(moment(b.date)))[0];

    if (!day)
        return null;

    const times = day.availableAppointments.filter(a => a.available);
    const slot = [...times].sort((a, b) => a.appointmentInit.localeCompare(b.appointmentInit))[0];

    return { date: moment(day.date), times, slot };
}

export const validateIsSameOfAfter = (current, dateToCompare) => {
    if (!dateToCompare)
        dateToCompare = moment().startOf('day');

    return moment(current).isSameOrAfter(dateToCompare);
}

export const isValidEventStart = (startDate) => {
    if (moment().isSameOrAfter(startDate)) {
        return false;
    }
    return true;
}

export function getAvailableTimes(start, end, interval) {
    var startTime = moment(start, 'HH:mm');
    var startTimeEnd = moment(start, 'HH:mm').add(interval, 'minutes');
    var endTime = moment(end, 'HH:mm');

    if (endTime.isBefore(startTime)) {
        endTime.add(1, 'day');
    }

    var timeStops = [];

    while (startTime <= endTime) {
        timeStops.push({ appointmentInit: startTime.format('HH:mm'), appointmentEnd: startTimeEnd.format('HH:mm') });
        startTime.add(interval, 'minutes');
        startTimeEnd.add(interval, 'minutes')
    }
    return timeStops;
}